import React, { useState, useEffect, useRef, FC } from 'react';
import { navigate } from '@reach/router';
import { loadInlineScript, loadScript } from '../helpers';
// import { FormContainer, PardotFormElement } from './PardotForm.styles';
import { v4 as uuidv4 } from 'uuid';

type PardotFormProps = {
  heading?: string;
  config?: string;
  wrapperStyles?: object;
}

const PardotForm: FC<PardotFormProps> = ({
  heading,
  config,
  wrapperStyles = {}
}) => {
  const id = `pardotForm_${uuidv4()}`;
  const formElementRef = useRef<any>(null);

  const baseConfigObject = {
    embedContext: 'form', // form|page|modal. Used for mixpanel trial_registration_context
    styleOverrides: '.form {padding: 0;}'
  }

  let configObject = {}
  try {
    configObject = JSON.parse(config) || {}
  } catch (e) {
    console.error('Error parsing pardot form config', e)
  }

  configObject = {...baseConfigObject, ...configObject};

  // Load pardot form after script isLoaded 
  useEffect(() => {
    const formScriptElement = document.createElement('script');
    formScriptElement.src = `https://scripts.thoughtspot.com/form_embed.bundle.js`;

    if (formElementRef.current) {
      loadScript("https://scripts.thoughtspot.com/form_embed.bundle.js", () => {}, id);
      loadInlineScript(JSON.stringify(configObject), 'application/json', {config: ''}, formElementRef.current);
    }
  }, [])

  return (
    <div style={wrapperStyles}>
      {heading}
      <div ref={formElementRef} id={id} data-thoughtspot-form style={configObject.embedStyle || {}}></div>
    </div>
  )
}

export default PardotForm